
    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '../../../lib/util'
    import AbpBase from '../../../lib/abpbase'

    import userList from '@/store/entities/userinfo'
    import PublicStoreEdit from '@/store/entities/back-public-stock-edit'
    import Enums from '@/lib/enums'
    import appconst from '@/lib/appconst';
    class Packed {
        ids: Array<number>;
        purchaseCost: number;
    }
    @Component
    export default class EditShilfPositionModule extends AbpBase {
        @Prop({ type: Boolean, default: false }) value: boolean;
        selectuser: userList = new userList();
        user: Array<userList> = [];
        automaticJump: boolean;
        PackedModel: Packed = new Packed();

        created() {

        }


        async check() {
            (this.$refs.packForm as any).validate(async (valid: boolean) => {
                if (valid) {
                    this.PackedModel.ids = this.$store.state.publicstockproduct.publicStockEdit.ids;
                    await this.$store.dispatch({
                        type: 'publicstockproduct/edit',
                        data: this.PackedModel
                    });
                    (this.$refs.packForm as any).resetFields();
                    this.$emit('save-success');
                    this.$emit('input', false);
                }
            })
            
        }


        cancel() {
            (this.$refs.packForm as any).resetFields();
            this.$emit('input', false);
        }
        visibleChange(value: boolean) {
            if (!value) {
                this.$emit('input', value);
            } else {
                this.$set(this.PackedModel, "purchaseCost", this.$store.state.frontstockproduct.purchaseCost);
            }
        }
    }
